/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : April 30, 2025
Folder          : src/components/homepage/index
File            : Homepage.tsx
Description     : 
    This component allows the user to access the homepage of the web app.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/



// Import React Systems
import { useState } from 'react'

// Imports MUI Components
import {
  Box,
  Grid,
  Link,
  Stack,
  Card,
  CardMedia,
  CardContent,
  Button
} from "@mui/material"

import Text from "../../../atoms/text/Text"
import AccordionComp from "../../../atoms/accordion/AccordionComp"

import clinicCard1 from "../../../../../assets/images/clinic1.jpg"
import clinicCard2 from "../../../../../assets/images/clinic2.jpg"
import clinicCard3 from "../../../../../assets/images/clinic3.jpg"
import serviceCard1 from "../../../../../assets/service1.jpg"
import serviceCard2 from "../../../../../assets/service2.jpeg"
import serviceCard3 from "../../../../../assets/service3.jpg"

import "./styles.css"

const Section = ({
  section,
  title,
  subtitle,
  destination
}) => {

  const gridStylesContainer = {
    backgroundColor: "transparent",
    justifyContent: "end",
    justifyItems: "center",
    alignItems: "center",
    alignContent: "center",
    padding: {
      xs: "80px 20px 80px 20px", 
      sm: "80px 30px 80px 30px", 
      md: "80px 110px 80px 110px", 
      lg: "80px 110px 80px 110px", 
      xl: "80px 110px 80px 110px" 
    },
    width: "100%",
    "& .MuiGrid-item": {
      display: "flex",
      justifyContent: "center",
    },
  }

  const boxStylesWrapper = {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
  }
  
  const boxStylesContainer = {
    height: "100%",
    justifyContent: "center",
    borderRadius: "20px",
    backgroundColor: "transparent",
    textAlign: "justify",
  }

  const cardStyleContainer = {
    height: "100%",
    alignContent: "center",
    textAlign: 
      section === "insurance" ? "center" :
      null,
    padding: 
      section === "team" ? "20px" :
      null,
    borderRadius: "20px",
    backgroundColor: 
      section === "team" ? "#FEFEFE" :
      section === "insurance" ? "#FEFEFE" :
      "transparent",
    boxShadow: 
      section === "team" ? "0 2px 5px rgba(0, 0, 0, 0.2)" :
      section === "insurance" ? "0 2px 5px rgba(0, 0, 0, 0.2)" :
      null,
  }

  return (
    <>
      {section !== "faqs" ? (
        <>
          {/*Grids */}
          <Grid
            container
            rowSpacing={4}
            columnSpacing={6}
            sx={gridStylesContainer}
          >

            {/* Title Wrapper */}
            <Box
              sx={boxStylesWrapper}
            >

              <Stack 
                direction={"column"}
              >

                <Text
                  text={title}
                  variant="h2"/>

                {subtitle !== "none" ? (
                  <Text
                    text={subtitle}
                    variant="indexHeroH3"/>
                ) : (
                  null
                )}
                

              </Stack>
                        
            </Box>

            {/* Content */}
            {[
              { 
                img: 
                  section === "clinic" ? clinicCard1 :
                  serviceCard1,
                title: 
                  section === "clinic" ? "Expertise" :
                  section === "team" ? "Dr. Julianne Vass M. Valle-So" :
                  "Dental Cleaning", 
                caption: 
                  section === "clinic" ? "Our clinic provides experienced and highly qualified specialists who are always ready to help you solve any dental problem." :
                  section === "team" ? "Dedicated to creating beautiful, lasting smiles, Dr. Julianne brings years of expertise in cosmetic and restorative dentistry. Her gentle approach and attention to detail make every patient feel comfortable and valued." :
                  null, 
              },
              { 
                img: 
                  section === "clinic" ? clinicCard2 : 
                  serviceCard2,
                title: 
                  section === "clinic" ? "Care" :
                  section === "team" ? "Dr. Jacky Anthony B. So" :
                  "Surgery", 
                caption:
                  section === "clinic" ? "Caring for your health is our priority, and we always strive to ensure recovery remains smooth, supportive, and comfortable." :
                  section === "team" ? "Known for his precision and steady hands, Dr. Jacky specializes in preventive care and oral surgery. His commitment to pain-free procedures and patient education ensures that every treatment is both effective and stress-free." :
                  null, 
              },
              ...(section !== "team"
                ? [{
                    img: section === "clinic" ? clinicCard3 : serviceCard3,
                    title: section === "clinic" ? "Comfort" : "Dentures",
                    caption: 
                      section === "clinic" ? "Designed with patient comfort at its core, our modern facility ensures every visit feels welcoming, relaxing, and stress-free." :
                      section === "team" ? "Expert in dental surgery and implant procedures." :
                      null, 
                  }]
                : [])
            ].map((content) => (
                
              <Grid 
                size={{
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: section === "team" ? 6 : 4,
                  xl: section === "team" ? 6 : 4 
                }} item
                sx={{
                  height: "100%"
                }}
              >

                <Box
                  sx={boxStylesContainer}
                >

                  <Card
                    elevation={0}
                    sx={cardStyleContainer}
                  >

                    {section !== "team" ? (
                      <CardMedia
                        component="img"
                        height="250px"
                        image={content.img}
                        alt="image"/>
                    ) : (null)}
                    
                    <CardContent
                    sx={{
    height: "100%",}}>

                      <Stack
                        direction="column"
                        spacing={2}>

                          <Text
                            text={content.title}
                            variant=
                              {section === "team" ? "indexH3" :
                                "h3"
                              }/>

                          <Text
                            text={content.caption}
                            variant="body1"/>
                      </Stack>

                    </CardContent>
                            
                  </Card>
            
                </Box>

              </Grid>

            ))}

            {section !== "insurance" ? (
              <>
                {/* Learn More Link */}
                <Link 
                  href={destination}
                  underline="none"
                >
                  <Button
                    class="learn-more"
                  >
                    <span class="circle" aria-hidden="true">
                    
                      <span class="icon arrow"/>

                    </span>

                    <span class="button-text">Learn More</span>

                  </Button> 

                </Link>
              </>
            ): (null)}

          </Grid>
        </>
      ) : (
        <>
          <AccordionComp/>
        </>
      )}
    </>
  )

}

export default Section;